import { z } from "zod";

// These schemas are for the portal REST endpoints mounted under `/portal/*`.
// They are NOT oRPC contracts and must NOT be added to the oRPC contract router.

// POST /portal/:portalId/auth/login
export const PortalLoginInputSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});

export const PortalLoginOutputSchema = z.object({
  success: z.boolean(),
  user: z.object({
    id: z.uuid(),
    name: z.string(),
    email: z.string().email(),
  }),
});

// POST /portal/:portalId/auth/logout
export const PortalLogoutOutputSchema = z.object({
  success: z.boolean(),
});

// GET /portal/:portalId/auth/me
export const PortalMeOutputSchema = z.object({
  user: z.object({
    id: z.uuid(),
    name: z.string(),
    email: z.string().email(),
    customerId: z.uuid(),
  }),
});

// GET /portal/:portalId/auth/portal-info
export const PortalInfoOutputSchema = z.object({
  portalName: z.string(),
  customerName: z.string(),
});

// GET /portal/auth/invite-info?token=...
export const PortalInviteInfoQuerySchema = z.object({
  token: z.string().min(1),
});

export const PortalInviteInfoOutputSchema = z.object({
  userName: z.string(),
  email: z.string().email(),
  expired: z.boolean(),
});

// POST /portal/auth/accept-invite
export const PortalAcceptInviteInputSchema = z.object({
  token: z.string().min(1),
  password: z.string().min(8),
});

export const PortalAcceptInviteOutputSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  redirectUrl: z.string(),
  email: z.string().email(),
});

// GET /portal/auth/my-portals
export const PortalMyPortalsQuerySchema = z.object({});

export const PortalMyPortalsOutputSchema = z.object({
  portals: z.array(
    z.object({
      id: z.uuid(),
      name: z.string(),
      slug: z.string(),
    }),
  ),
});

export type PortalLoginInput = z.infer<typeof PortalLoginInputSchema>;
export type PortalLoginOutput = z.infer<typeof PortalLoginOutputSchema>;

export type PortalLogoutOutput = z.infer<typeof PortalLogoutOutputSchema>;
export type PortalMeOutput = z.infer<typeof PortalMeOutputSchema>;
export type PortalInfoOutput = z.infer<typeof PortalInfoOutputSchema>;

export type PortalInviteInfoQuery = z.infer<typeof PortalInviteInfoQuerySchema>;
export type PortalInviteInfoOutput = z.infer<
  typeof PortalInviteInfoOutputSchema
>;

export type PortalAcceptInviteInput = z.infer<
  typeof PortalAcceptInviteInputSchema
>;
export type PortalAcceptInviteOutput = z.infer<
  typeof PortalAcceptInviteOutputSchema
>;

export type PortalMyPortalsQuery = z.infer<typeof PortalMyPortalsQuerySchema>;
export type PortalMyPortalsOutput = z.infer<typeof PortalMyPortalsOutputSchema>;
